import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";
import { deleteGovernorate } from "../../../../../services/Admin/ShippingCategoriesApi";

const DeleteGovernorateDialog = ({ open, onClose, onSuccess, governorate }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    if (!governorate?.id) return;
    setError("");
    setLoading(true);
    try {
      const res = await deleteGovernorate(governorate.id);
      if (res?.success) {
        onSuccess?.();
        onClose?.();
      } else {
        setError(res?.message || "فشل حذف المحافظة");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء الحذف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تأكيد حذف المحافظة</DialogTitle>
      <DialogContent>
        <Typography>
          هل أنت متأكد من حذف المحافظة <strong>{governorate?.name_ar || governorate?.name_en || ""}</strong>؟
        </Typography>
        {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حذف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteGovernorateDialog;
